import axios from 'axios';
import qs from 'qs';


const url = '/api/configuration/team';

export const getList = ({
    q,
    groupId,
    projects,
    userId,
     } = {}) => axios.get(url, {
        params: {
            q,
            groupId,
            projects,
            userId,
        },
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
        .then(response => response.data);



// WEBPACK FOOTER //
// ../utils/api/configuration/team.js